var map = {
	"./about-img.svg": 385,
	"./headset.svg": 192,
	"./main-logo.svg": 386,
	"./premium.svg": 387,
	"./proffessional.svg": 388,
	"./shap-01.svg": 389,
	"./shap-02.svg": 390,
	"./starter.svg": 391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 384;